export const MIGRATED_ROUTES = [
    '/dashboard',
    '/login',
    '/forgot_password',
    '/reset_password',
    '/auth0_callback',
    '/tabs-example',
    '/tabs-example-search'
];
export const shouldUseRR7 = (pathname) => {
    return MIGRATED_ROUTES.some(route => pathname.startsWith(route));
};
